import {course_getTeachers_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import {createValue} from 'components/form/utils'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import ContainerPicker from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {InnerWrapper, renderBaseOption} from '../../../../components/selectors/BaseSelector'
import {renderIf} from "../../../Shared";
import {IdcodeTag} from "../../../../components/common/IdcodeTag";

export const TeacherSelector = ({
                                    name,
                                    value,
                                    owner_id,
                                    owner_type,
                                    not_course_id,
                                    onChange = NullAsDefault,
                                    ...props
                                }) => {
    const t = useTranslate()
    const defaultValue = getId(value) ?? value;

    // Chỉ cho CHỌN MỚI giáo viên đang hoạt động (active: 1 ở customConfigs.values bên dưới) - gán
    // vai trò/lịch dạy mới cho 1 giáo viên đã "Tạm ngưng hoạt động" (xem Teachers.js) không hợp lý.
    // Nhưng KHÔNG được làm mất hiển thị giáo viên đã gán TỪ TRƯỚC nếu người đó sau đó mới tạm ngưng
    // (đang sửa 1 lịch/lớp cũ) - ContainerPicker chỉ resolve được defaultValue khi nó có mặt trong
    // danh sách vừa fetch (mà server giờ đã lọc bỏ inactive), nên phải tự chèn `value` (object gốc,
    // không phải chỉ id) vào đầu danh sách nếu nó chưa có sẵn.
    const withResponses = useCallback(
        (items = []) => {
            if (!_.isObject(value) || !getId(value)) return items
            return items.some((e) => getId(e) === getId(value)) ? items : [value, ...items]
        },
        [value]
    )

    return (
        <ContainerPicker
            name={name}
            allowClear={true}
            defaultValue={defaultValue}
            type={AppEntities.UNDEFINED}
            placeholder="click to select"
            renderInnerWrapper={InnerWrapper}
            withResponses={withResponses}
            onOptionChange={(option) => {
                onChange(createValue(name, option ?? null))
            }}
            renderOption={renderBaseOption(defaultValue, (option) => ({
                // IdcodeTag (teacher_idcode) - trước đây chọn xong chỉ thấy tên, không có mã tham
                // chiếu như Course/CourseClass selector khác (bạn báo thiếu) - cùng style
                // <IdcodeTag> đã dùng ở CourseSelector.js/CourseClassSelector.js, không tự chế mới.
                title: (
                    <div className="text-sm flex items-center gap-1.5">
                        {renderIf(option?.teacher_idcode, <IdcodeTag>{option.teacher_idcode}</IdcodeTag>)}
                        <span className="truncate">
                            {renderIf(
                                option?.prefix_title,
                                <span className="font-normal text-color-200 italic">{option?.prefix_title}{'. '}</span>
                            )}
                            <span className="font-bold text-color-000">{option?.fullname}</span>
                        </span>
                        {/* Chỉ có thể xuất hiện ở đây khi đó là giáo viên ĐÃ gán từ trước (chèn qua
                            withResponses ở trên) - option mới fetch từ server luôn active=1 rồi. */}
                        {renderIf(
                            option?.active === 0,
                            <span className="shrink-0 px-1.5 py-0.5 rounded-full bg-orange-50 text-orange-500 text-2xs font-semibold whitespace-no-wrap">
                                {t('temporarily inactive')}
                            </span>
                        )}
                    </div>
                ),
                description: <span className="text-green-300">{t(getType(option))}</span>,
            }))}
            customConfigs={{
                apiInfo: course_getTeachers_Api,
                query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
                values: {not_course_id, active: 1},
            }}
            {...props}
        />
    )
}
